import { DashboardTab } from "../dashboard/DashboardTab";
import { ResearchModePanel } from "../research/ResearchModePanel";
import { BlindCodingTab } from "../blind-coding/BlindCodingTab";
import { RegionalExplorer } from "../regional/RegionalExplorer";
import { ExtractionAnatomy } from "../extraction/ExtractionAnatomy";
import { ContributeTab } from "../contribute/ContributeTab";
import { IndustryTrends } from "../trends/IndustryTrends";
import { AboutPage } from "../about/AboutPage";
import { ConstellationTab } from "../constellation/ConstellationTab";
import { MirrorPage } from "../mirror/MirrorPage";
import { OrientationAnatomy } from "../anatomy/OrientationAnatomy";
import { PhysicalAIAnatomy } from "../anatomy/PhysicalAIAnatomy";
import { HardwareDashboard } from "../galaxy/HardwareDashboard";
import { HardwareExplorer } from "../galaxy/HardwareExplorer";
import { GalaxyProvider } from "../galaxy/GalaxyContext";
import { GalaxyRegional, GalaxyTrends, GalaxyInsights } from "../galaxy/GalaxyViews";
import { CountryCompare } from "../galaxy/CountryCompare";

import { ConsciousnessDashboard } from "../galaxy/ConsciousnessDashboard";
import { PossibilityEngine } from "../galaxy/PossibilityEngine";
import { IndustryObservatory } from "../industry/IndustryObservatory";
import { IndustryFutures } from "../industry/IndustryFutures";
import { ResearchObservatory } from "../research/ResearchObservatory";
import { ResearchExplorer } from "../research/ResearchExplorer";
import { ResearchGapAnalysis } from "../research/ResearchGapAnalysis";
import { ResearchFields } from "../research/ResearchFields";
import { ResearchPulse } from "../research/ResearchPulse";
import { ResearchTrendsRadar } from "../research/ResearchTrendsRadar";
import { PolicyInfluence } from "../research/PolicyInfluence";
import { GeoIntelligence } from "../research/GeoIntelligence";
import { CompanyObservatory } from "../company/CompanyObservatory";
import { CompanyDetail } from "../company/CompanyDetail";
import { CompanyCompare } from "../company/CompanyCompare";
import { CompanySolutions } from "../company/CompanySolutions";
import { ProductExplorer } from "../company/ProductExplorer";
import { CompanyDatabase } from "../company/CompanyDatabase";
import { PolicyObservatory } from "../policy/PolicyObservatory";
import { PolicyExplorer } from "../policy/PolicyExplorer";
import { PolicyRegional } from "../policy/PolicyRegional";
import { PolicyCompare } from "../policy/PolicyCompare";
import { CorporatePolicyLens } from "../policy/CorporatePolicyLens";
import { PolicyTimeline } from "../policy/PolicyTimeline";
import { PolicyReadiness } from "../policy/PolicyReadiness";
import { EquityLens } from "../equity/EquityLens";
import { DeepQuery } from "../insights/DeepQuery";
import { DataExplorerTab } from "../explorer/DataExplorerTab";
import { InsightsTab } from "../insights/InsightsTab";
import { SubmitAppForm } from "../contribute/SubmitAppForm";

export const ContentRouter = ({
  activeGalaxy,
  activeTab,
  // Apps galaxy props
  stats,
  researchStats,
  apps,
  filteredApps,
  filters,
  setFilters,
  searchTerm,
  setSearchTerm,
  setSelectedApp,
  setShowCorrectionModal,
  insights,
  insightsLoading,
  generateInsights,
  setShowInfographicModal,
  fetchResearchStats,
  showNotification,
  // Companies galaxy props
  companyDetailDomain,
  setCompanyDetailDomain,
  setCompanyCompareDomains,
  companyCompareDomains,
  setActiveTab,
  // Consciousness props
  setActiveGalaxy,
}) => {
  return (
    <div style={{ padding: "var(--content-padding)", maxWidth: "var(--content-max)", margin: "0 auto" }}>
      {/* Consciousness Dashboard (Universe view) */}
      {activeGalaxy === "consciousness" && (<>
        {activeTab === "c-dashboard" && <ConsciousnessDashboard setActiveGalaxy={setActiveGalaxy} />}
        {activeTab === "c-possibility" && <PossibilityEngine />}
        {activeTab === "c-compare" && <CountryCompare />}
        {activeTab === "c-regional" && <RegionalExplorer />}
        {activeTab === "c-industries" && <IndustryObservatory />}
        {activeTab === "c-futures" && <IndustryFutures />}
        {activeTab === "c-trends" && <IndustryTrends />}
        {activeTab === "constellation" && <ConstellationTab />}
        {activeTab === "c-equity" && <EquityLens />}
        {activeTab === "mirror" && <MirrorPage />}
        {activeTab === "insights" && <DeepQuery />}
        {activeTab === "about" && <AboutPage />}
        {activeTab === "contribute" && <ContributeTab showNotification={showNotification} />}
      </>)}

      {/* Galaxy 1: AI Apps */}
      {activeGalaxy === "apps" && (<>
        {activeTab === "dashboard" && <DashboardTab stats={stats} researchStats={researchStats} />}
        {activeTab === "regional" && <RegionalExplorer entityType="application" />}
        {activeTab === "compare" && <CountryCompare entityType="application" />}
        {activeTab === "extraction" && <ExtractionAnatomy />}
        {activeTab === "care-anatomy" && <OrientationAnatomy orientation="care" />}
        {activeTab === "utility-anatomy" && <OrientationAnatomy orientation="utility" />}
        {activeTab === "creative-anatomy" && <OrientationAnatomy orientation="creative" />}
        {activeTab === "trends" && <IndustryTrends />}
        {activeTab === "contribute" && <ContributeTab showNotification={showNotification} />}
        {activeTab === "explorer" && (
          <DataExplorerTab
            apps={apps}
            filteredApps={filteredApps}
            filters={filters}
            setFilters={setFilters}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            stats={stats}
            setSelectedApp={setSelectedApp}
            setShowCorrectionModal={setShowCorrectionModal}
          />
        )}
        {activeTab === "submit" && <ContributeTab showNotification={showNotification} />}
        {activeTab === "insights" && (
          <InsightsTab
            insights={insights}
            insightsLoading={insightsLoading}
            generateInsights={generateInsights}
            stats={stats}
            researchStats={researchStats}
            onShowInfographic={() => setShowInfographicModal(true)}
          />
        )}
        {activeTab === "blind-coding" && <BlindCodingTab showNotification={showNotification} />}
        {activeTab === "research" && (
          <ResearchModePanel researchStats={researchStats} onLoad={fetchResearchStats} showNotification={showNotification} />
        )}
        {activeTab === "mirror" && <MirrorPage />}
        {activeTab === "about" && <AboutPage />}
      </>)}

      {/* Galaxy 2: Physical AI */}
      {activeGalaxy === "hardware" && (
        <GalaxyProvider value={{ entityType: "device", galaxyId: "hardware" }}>
          <>
            {activeTab === "hw-dashboard" && <HardwareDashboard />}
            {activeTab === "hw-anatomy" && <PhysicalAIAnatomy />}
            {activeTab === "hw-care" && <OrientationAnatomy orientation="care" entityType="device" />}
            {activeTab === "hw-utility" && <OrientationAnatomy orientation="utility" entityType="device" />}
            {activeTab === "hw-creative" && <OrientationAnatomy orientation="creative" entityType="device" />}
            {activeTab === "hw-extraction" && <OrientationAnatomy orientation="extraction" entityType="device" />}
            {activeTab === "hw-regional" && <RegionalExplorer entityType="device" />}
            {activeTab === "hw-compare" && <CountryCompare entityType="device" />}
            {activeTab === "hw-trends" && <IndustryTrends />}
            {activeTab === "hw-explorer" && <HardwareExplorer />}
            {activeTab === "hw-insights" && <DeepQuery />}
            {activeTab === "hw-research" && <ResearchModePanel stats={stats} researchStats={researchStats} />}
            {activeTab === "about" && <AboutPage />}
          </>
        </GalaxyProvider>
      )}

      {/* Research Galaxy */}
      {activeGalaxy === "research" && (<>
        {activeTab === "r-dashboard" && <ResearchObservatory />}
        {activeTab === "r-explorer" && <ResearchExplorer />}
        {activeTab === "r-fields" && <ResearchFields />}
        {activeTab === "r-gap" && <ResearchGapAnalysis />}
        {activeTab === "r-pulse" && <ResearchPulse />}
        {activeTab === "r-trends" && <ResearchTrendsRadar />}
        {activeTab === "r-policy" && <PolicyInfluence />}
        {activeTab === "r-geo" && <GeoIntelligence />}
        {activeTab === "about" && <AboutPage />}
        {activeTab === "contribute" && <SubmitAppForm onSuccess={() => showNotification("Submitted!", "success")} />}
      </>)}

      {/* Galaxy 3: Companies */}
      {activeGalaxy === "companies" && (<>
        {activeTab === "co-dashboard" && (
          <CompanyObservatory
            onViewDetail={(domain) => { setCompanyDetailDomain(domain); setActiveTab("co-detail"); }}
            onCompare={(domain) => { setCompanyCompareDomains([domain]); setActiveTab("co-compare"); }}
          />
        )}
        {activeTab === "co-detail" && companyDetailDomain && (
          <CompanyDetail
            domain={companyDetailDomain}
            onBack={() => { setCompanyDetailDomain(null); setActiveTab("co-dashboard"); }}
            onCompare={(domain) => { setCompanyCompareDomains([domain]); setCompanyDetailDomain(null); setActiveTab("co-compare"); }}
          />
        )}
        {activeTab === "co-detail" && !companyDetailDomain && (
          <div className="text-center py-24 animate-fade-in" data-testid="co-detail-empty">
            <p className="text-sm text-slate-400 mb-2">No company selected.</p>
            <p className="text-[11px] text-slate-500 mb-4">This can happen after a hard refresh or when navigating from a stale link.</p>
            <button
              onClick={() => setActiveTab("co-dashboard")}
              className="text-xs text-amber-400 hover:text-amber-300 font-medium"
              data-testid="co-detail-empty-back"
            >
              ← Back to Company Leaderboard
            </button>
          </div>
        )}
        {activeTab === "co-solutions" && (
          <CompanySolutions
            onViewDetail={(domain) => { setCompanyDetailDomain(domain); setActiveTab("co-detail"); }}
          />
        )}
        {activeTab === "co-products" && <ProductExplorer />}
        {activeTab === "co-database" && <CompanyDatabase
            onViewDetail={(domain) => { setCompanyDetailDomain(domain); setActiveTab("co-detail"); }}
        />}
        {activeTab === "co-compare" && (
          <CompanyCompare
            initialDomains={companyCompareDomains}
            onBack={() => { setCompanyCompareDomains([]); setActiveTab("co-dashboard"); }}
            onViewDetail={(domain) => { setCompanyDetailDomain(domain); setActiveTab("co-detail"); }}
          />
        )}
        {activeTab === "about" && <AboutPage />}
        {activeTab === "contribute" && <SubmitAppForm onSuccess={() => showNotification("Submitted!", "success")} />}
      </>)}

      {/* Galaxy 4: Policy */}
      {activeGalaxy === "policy" && (<>
        {activeTab === "po-dashboard" && <PolicyObservatory />}
        {activeTab === "po-explorer" && <PolicyExplorer />}
        {activeTab === "po-readiness" && <PolicyReadiness />}
        {activeTab === "po-regional" && <PolicyRegional />}
        {activeTab === "po-compare" && <PolicyCompare />}
        {activeTab === "po-corporate" && <CorporatePolicyLens />}
        {activeTab === "po-timeline" && <PolicyTimeline />}
        {activeTab === "about" && <AboutPage />}
        {activeTab === "contribute" && <ContributeTab showNotification={showNotification} />}
      </>)}
    </div>
  );
};
